import { render, staticRenderFns } from "./driverLog.vue?vue&type=template&id=2604ac8a&"
import script from "./driverLog.vue?vue&type=script&lang=js&"
export * from "./driverLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports